module.exports = __webpack_public_path__ + "img/EXTERIOR-ERTIGA-5.996f9f74.jpg";